import { sum } from 'lodash'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

import { FooterModalButtons } from '../FooterModalButtons'
import { ReconciliationItem, ReconciliationSource } from '../types'

interface PartialPendingJournalModalProps {
  source: ReconciliationSource
  selectedReconciliations: ReconciliationItem[]
  locale: string
  isBankJournalLine: boolean
  onClose: () => void
  onConfirm: () => void
}

export const PartialPendingJournalModal = ({
  source,
  selectedReconciliations,
  locale,
  isBankJournalLine,
  onClose,
  onConfirm,
}: PartialPendingJournalModalProps) => {
  const partialAmountCents = isBankJournalLine
    ? sum(selectedReconciliations.map((el) => el.creditCentsToReconcile + el.debitCentsToReconcile))
    : source.creditCentsToReconcile + source.debitCentsToReconcile

  const totalAmountCents = isBankJournalLine
    ? source.creditCentsToReconcile + source.debitCentsToReconcile
    : sum(selectedReconciliations.map((el) => el.creditCentsToReconcile + el.debitCentsToReconcile))

  const journalLineDescription = isBankJournalLine
    ? source.description
    : selectedReconciliations[0]?.description || '-'
  return (
    <Modal
      onClose={onClose}
      title={i18n.t('finance.reconciliations.partial_bank_journal_modal.title')}
      description={i18n.t('finance.reconciliations.partial_bank_journal_modal.subtitle', {
        partial: formattedAmount({
          amountCents: partialAmountCents,
          currency: source.currency,
          locale: locale,
        }),
        total: formattedAmount({
          amountCents: totalAmountCents,
          currency: source.currency,
          locale: locale,
        }),
        journal_line_description: journalLineDescription,
      })}
      illustration="alert"
      footer={<FooterModalButtons onCancel={onClose} onConfirm={onConfirm} />}
    />
  )
}
